export default "__VITE_ASSET__d5665357__"